import { Config } from './constants';

export const getConfigRequest = () => ({ type: Config.getConfigRequest });
export const getConfigSuccess = (data) => ({ type: Config.getConfigSuccess, data });
export const getConfigError = (err) => ({ type: Config.getConfigError, err });
